import { useTranslation } from '@spcc/core'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@spcc/uikit'
import { AddressRow } from './address-row'
import type { AddressbookTableProps } from '../types'

export function AddressbookTable({
  addresses,
  selectedRowId,
  showTenantColumn,
  onRowClick,
  onRowDoubleClick,
  onEdit,
  onDelete,
  isArabic,
}: AddressbookTableProps) {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden border border-border/50">
      <Table>
        <TableHeader>
          <TableRow className="border-border/40 hover:bg-transparent bg-muted/50">
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('addressbook.name')}
            </TableHead>
            {showTenantColumn && (
              <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
                {t('common.tenant')}
              </TableHead>
            )}
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('addressbook.address')}
            </TableHead>
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('addressbook.city')}
            </TableHead>
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider text-end w-[100px]">
              {t('addressbook.actions')}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {addresses.map((address) => (
            <AddressRow
              key={address.id}
              address={address}
              isSelected={selectedRowId === address.id}
              showTenantColumn={showTenantColumn}
              onClick={() => onRowClick(address)}
              onDoubleClick={() => onRowDoubleClick(address)}
              onEdit={onEdit}
              onDelete={onDelete}
              isArabic={isArabic}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
